import classNames from 'classnames';

import { NetPriceTranslation } from '../../localization/ModuleTranslation';
import Price from '../../ui/Price/Price';
import css from './NetPrice.css';

interface NetPriceProps {
  /** Missing when the dealer has no agreement for the product. */
  amount?: number;
  translation: NetPriceTranslation;
  className?: string;
}

const NetPrice = ({ amount, translation, className }: NetPriceProps) => {
  if (amount == null) {
    return <span className={classNames(css.notAvailable, className)}>{translation.notAvailable}</span>;
  }

  return <Price className={className} amount={amount} />;
};

export default NetPrice;
